import React from 'react';
import { createNativeStackNavigator } from '@react-navigation/native-stack';

// Personal checklist screen
import { PersonalChecklistScreen } from '../../screens/checklists/PersonalChecklistScreen';

// Personal Information screens
import { PersonalInfoIntroScreen } from '../../screens/tasks/personal/information/PersonalInfoIntroScreen';
import { PersonalInfoInputScreen } from '../../screens/tasks/personal/information/PersonalInfoInputScreen';
import { PersonalInfoDataScreen } from '../../screens/tasks/personal/information/PersonalInfoDataScreen';
import { PersonalInfoLockUnlockScreen } from '../../screens/tasks/personal/information/PersonalInfoLockUnlockScreen';
import { PersonalInfoLockedScreen } from '../../screens/tasks/personal/information/PersonalInfoLockedScreen';
import { PersonalInfoUnlockedScreen } from '../../screens/tasks/personal/information/PersonalInfoUnlockedScreen';

// Employment Information screens
import { EmploymentIntroScreen } from '../../screens/tasks/personal/employment/EmploymentIntroScreen';
import { EmploymentInfoInputScreen } from '../../screens/tasks/personal/employment/EmploymentInfoInputScreen';
import { EmploymentInfoDataScreen } from '../../screens/tasks/personal/employment/EmploymentInfoDataScreen';
import { EmploymentLockUnlockScreen } from '../../screens/tasks/personal/employment/EmploymentLockUnlockScreen';
import { EmploymentInfoLockedScreen } from '../../screens/tasks/personal/employment/EmploymentInfoLockedScreen';
import { EmploymentInfoUnlockedScreen } from '../../screens/tasks/personal/employment/EmploymentInfoUnlockedScreen';

// Spouse Information screens
import { SpouseIntroScreen } from '../../screens/tasks/personal/spouse/SpouseIntroScreen';
import { SpouseInfoInputScreen } from '../../screens/tasks/personal/spouse/SpouseInfoInputScreen';
import { SpouseInfoDataScreen } from '../../screens/tasks/personal/spouse/SpouseInfoDataScreen';
import { SpouseInfoLockUnlockScreen } from '../../screens/tasks/personal/spouse/SpouseInfoLockUnlockScreen';
import { SpouseInfoLockedScreen } from '../../screens/tasks/personal/spouse/SpouseInfoLockedScreen';
import { SpouseInfoUnlockedScreen } from '../../screens/tasks/personal/spouse/SpouseInfoUnlockedScreen';

// Children Information screens
import { ChildrenInfoInputScreen } from '../../screens/tasks/personal/children/ChildrenInfoInputScreen';
import { ChildrenIntroScreen } from '../../screens/tasks/personal/children/ChildrenIntroScreen';
import { ChildrenInfoDataScreen } from '../../screens/tasks/personal/children/ChildrenInfoDataScreen';
import { ChildrenInfoLockUnlockScreen } from '../../screens/tasks/personal/children/ChildrenInfoLockUnlockScreen';
import { ChildrenInfoLockedScreen } from '../../screens/tasks/personal/children/ChildrenInfoLockedScreen';
import { ChildrenInfoUnlockedScreen } from '../../screens/tasks/personal/children/ChildrenInfoUnlockedScreen';

// Pet Information screens
import { PetInfoInputScreen } from '../../screens/tasks/personal/pets/PetInfoInputScreen';
import { PetIntroScreen } from '../../screens/tasks/personal/pets/PetIntroScreen';
import { PetInfoDataScreen } from '../../screens/tasks/personal/pets/PetInfoDataScreen';
import { PetInfoLockUnlockScreen } from '../../screens/tasks/personal/pets/PetInfoLockUnlockScreen';
import { PetInfoLockedScreen } from '../../screens/tasks/personal/pets/PetInfoLockedScreen';
import { PetInfoUnlockedScreen } from '../../screens/tasks/personal/pets/PetInfoUnlockedScreen';

const Stack = createNativeStackNavigator();

const PersonalStackNavigator: React.FC = () => {
  return (
    <Stack.Navigator
      screenOptions={{
        headerShown: false,
      }}
    >
      {/* Main Personal Checklist */}
      <Stack.Screen name="PersonalChecklist" component={PersonalChecklistScreen} />
      
      {/* Personal Information Screens */}
      <Stack.Screen name="PersonalInfoIntro" component={PersonalInfoIntroScreen} />
      <Stack.Screen name="PersonalInfoInput" component={PersonalInfoInputScreen} />
      <Stack.Screen name="PersonalInfoData" component={PersonalInfoDataScreen} />
      <Stack.Screen name="PersonalInfoLockUnlock" component={PersonalInfoLockUnlockScreen} />
      <Stack.Screen name="PersonalInfoLocked" component={PersonalInfoLockedScreen} />
      <Stack.Screen name="PersonalInfoUnlocked" component={PersonalInfoUnlockedScreen} />
      
      {/* Employment Information Screens */}
      <Stack.Screen name="EmploymentInfoIntro" component={EmploymentIntroScreen} />
      <Stack.Screen name="EmploymentInfoInput" component={EmploymentInfoInputScreen} />
      <Stack.Screen name="EmploymentInfoData" component={EmploymentInfoDataScreen} />
      <Stack.Screen name="EmploymentLockUnlock" component={EmploymentLockUnlockScreen} />
      <Stack.Screen name="EmploymentInfoLocked" component={EmploymentInfoLockedScreen} />
      <Stack.Screen name="EmploymentInfoUnlocked" component={EmploymentInfoUnlockedScreen} />
      
      {/* Spouse Information Screens */}
      <Stack.Screen name="SpouseInfoIntro" component={SpouseIntroScreen} />
      <Stack.Screen name="SpouseInfoInput" component={SpouseInfoInputScreen} />
      <Stack.Screen name="SpouseInfoData" component={SpouseInfoDataScreen} />
      <Stack.Screen name="SpouseInfoLockUnlock" component={SpouseInfoLockUnlockScreen} />
      <Stack.Screen name="SpouseInfoLocked" component={SpouseInfoLockedScreen} />
      <Stack.Screen name="SpouseInfoUnlocked" component={SpouseInfoUnlockedScreen} />
      
      {/* Children Information Screens */}
      <Stack.Screen name="ChildrenInfoInput" component={ChildrenInfoInputScreen} />
      <Stack.Screen name="ChildrenInfoIntro" component={ChildrenIntroScreen} />
      <Stack.Screen name="ChildrenInfoData" component={ChildrenInfoDataScreen} />
      <Stack.Screen name="ChildrenInfoLockUnlock" component={ChildrenInfoLockUnlockScreen} />
      <Stack.Screen name="ChildrenInfoLocked" component={ChildrenInfoLockedScreen} />
      <Stack.Screen name="ChildrenInfoUnlocked" component={ChildrenInfoUnlockedScreen} />
      
      {/* Pet Information Screens */}
      <Stack.Screen name="PetInfoInput" component={PetInfoInputScreen} />
      <Stack.Screen name="PetInfoIntro" component={PetIntroScreen} />
      <Stack.Screen name="PetInfoData" component={PetInfoDataScreen} />
      <Stack.Screen name="PetInfoLockUnlock" component={PetInfoLockUnlockScreen} />
      <Stack.Screen name="PetInfoLocked" component={PetInfoLockedScreen} />
      <Stack.Screen name="PetInfoUnlocked" component={PetInfoUnlockedScreen} />
    </Stack.Navigator>
  );
};

export default PersonalStackNavigator;